import { render, staticRenderFns } from "./StuDetail.vue?vue&type=template&id=1ce91427&scoped=true"
import script from "./StuDetail.vue?vue&type=script&lang=js"
export * from "./StuDetail.vue?vue&type=script&lang=js"
import style0 from "./StuDetail.vue?vue&type=style&index=0&id=1ce91427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce91427",
  null
  
)

export default component.exports